
    import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { Dispatch } from "redux";
import { UpdateDocumentAdditionalData } from "./UpdateDocumentAdditionalData";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";

export const updateDocumentBusinessIdActionTypes = createRequestActionTypes('UPDATE_DOCUMENT_BUSINESSID')

export type UpdateDocumentBusinessIdAdditionalData = UpdateDocumentAdditionalData & {
    ignoreResultTitle?: boolean
}
type Options = {
    ignoreResultTitle?: boolean
}

export const updateDocumentBusinessId = (config: ApiConfig) => (docId: string, businessId: string, dataType: string, options?: Options) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Document, any, UpdateDocumentBusinessIdAdditionalData> = {
        method: 'POST',
        requestActionTypes: updateDocumentBusinessIdActionTypes,
        url: `${config.API_URL}/content/update-businessId?id=${encodeURIComponent(docId)}`,
        actionAdditionalData: { docId, ...options },
        processResultBeforeDispatch: (doc: Document) => {

            if(!Object.keys(doc).length) {
                throw new Error("Business id already exists")
            }
            
            if (config.updateItem) {
                config.updateItem(docId)
            }

            return doc
        },
        body: {
            businessId: businessId,
            dataType: dataType
        }
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}
